import React, { Component } from 'react';
import './OnboardingContainerAA.css';

class SkinQuizTransition extends Component {
    constructor(props) {
        super(props);
    }

    funStateQuiz(){
        this.props.funStateQuiz();
    }

    render() {
        return (
            <div className="quiz-explain-container">
                <img className="quiz-explain-img" src="/images/onboardingAA/care.png"></img>
                <div className="quiz-explain-title paragraphSemiBold0">Take our skin quiz!</div>
                <div className="quiz-explain-text paragraphRegular3">Our science-based quiz will ask you a series of questions to learn about your skin type, concerns, and preferences. </div>
                <button className="p-a-n-button" onClick={()=>{ this.funStateQuiz()  }}>Let’s go!</button>
            </div>
        )
    }
}

export default SkinQuizTransition



// WEBPACK FOOTER //
// ./src/views/onboardingAA/SkinQuizTransition.js